
import { useAuth } from "../../contexts/AuthContext";
import { useEffect, useState } from "react";
import { supabase } from "../../lib/supabase";
import { useUserTimezone } from "../../hooks/useUserTimezone";
import { formatInTimeZone } from "date-fns-tz";
import React from "react";

export function HelloBlock() {
  const { user } = useAuth();
  const [firstName, setFirstName] = useState<string>("");
  const { timezone } = useUserTimezone();
  
  useEffect(() => {
    const fetchProfile = async () => {
      if (!user?.id) return;
      
      const { data, error } = await supabase
        .from("profiles")
        .select("first_name")
        .eq("id", user.id)
        .single();
        
      if (error) {
        console.error("Error fetching profile:", error);
        return;
      }
      
      setFirstName(data?.first_name || "");
    };
    
    fetchProfile();
  }, [user?.id]);

  const formattedDate = formatInTimeZone(
    new Date(),
    timezone,
    "EEEE, MMMM d"
  ).toUpperCase();

  return (
    <div className="animate-fade-in pt-4">
      <p className="text-sm text-red-600 font-bold tracking-tight">
        {formattedDate}
      </p>
      <p className="text-6xl font-poppins font-extrabold tracking-tight text-foreground">
        Hello {firstName || "there"}
      </p>
      <p className="text-lg font-light text-muted-foreground">
        We'll get to work so you don't have to.
      </p>
    </div>
  );
}